<template>
  <div>
    <mq-layout :mq="['sm', 'md']">
      <MobileHeader :social="true" />
    </mq-layout>
    <mq-layout mq="lg+">
      <header id="header" class="header" :class="$mq">
        <div class="header__content">
          <nav id="navi">
            <BaseHamburgerNavigation />
          </nav>
          <div class="right">
            <component
              :is="companySocial"
              :instagram="true"
              :facebook="true"
              :youtube="false"
              v-if="social"
              class="header__social"
            ></component>
          </div>
        </div>
      </header>
    </mq-layout>
  </div>
</template>

<script>
export default {
  props: {
    social: {
      type: Boolean,
      default: true,
    },
    kinofinder: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    companySocial() {
      return () =>
        import(
          `@/website_elements/global/companies/${this.$config.verantwortlich.toLowerCase()}/Social.vue`
        )
    },
  },
  mounted() {
    this.$nextTick(function () {
      const hdr = window.document.getElementById('header')
      window.addEventListener('scroll', function () {
        if (window.scrollY > 100) {
          hdr.classList.add('bgc')
        } else {
          hdr.classList.remove('bgc')
        }
      })
    })
  },
}
</script>

<style lang="scss" scoped>
.bgc {
  background-color: #fff !important;
}
.header {
  $self: &;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: var(--height-header);
  background-color: transparent;
  z-index: 9999;
  overflow: hidden;
  &__content {
    position: relative;
    display: flex;
    flex-direction: row;
    padding: var(--p-header);
    height: var(--height-header);
    .right {
      .bg_color {
        position: absolute;
        right: 0;
        top: 0;
        display: block;
        transition: top 0.3s;
      }
    }
  }
  &__social {
    position: absolute;
    top: 0px;
    right: 15px;
    text-align: right;
  }
}
</style>
